module.exports = __webpack_public_path__ + "static/img/ket-renewal-mobile-main-02@t.c9dce65.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-mobile-main-02@t.png
// module id = +/kB
// module chunks = 0